<template lang="pug">
div.datacenter
  RadioGroup(v-model="staRadio" type="button").RadioGroup
    Radio(label='学习资料')
    Radio(label='专业名词')
    Radio(label='网络链接')
  div(v-show="staRadio=='学习资料'",style="margin-top: 20px")
    Table(:columns="columns1" :data="learndata",@on-selection-change="handleSelectionChange")
    Page.page(@on-change="handleCurrentChange" :total="pageData.totalRecords"
         :page-size="10" :current="pageData.pageNo" show-elevator)
    Button(type="primary",style="margin:10px 10px 0 10px",size="large",@click="downloadfiledx") 导出
  div(v-show="staRadio=='专业名词'",style="margin-top: 20px")
    Table(:columns="columns2" :data="learnnoun",@on-selection-change="handleSelectionChange")
    Page.page(@on-change="handleCurrentChange2" :total="pageData2.totalRecords"
         :page-size="10" :current="pageData2.pageNo" show-elevator)
  div(v-show="staRadio=='网络链接'",style="margin-top: 20px")
    Table(:columns="columns3" :data="learnlink",@on-selection-change="handleSelectionChange")
    Page.page(@on-change="handleCurrentChange3" :total="pageData3.totalRecords"
         :page-size="10" :current="pageData3.pageNo" show-elevator)
</template>
<script>
import dayjs from "dayjs";

export default {
  data() {
    return {
      stuteacher: "", // 学生被管理的老师
      stuclass: "", // 学生所在的班级
      pageData: {}, // 表格分页数据
      pageData2: {},
      pageData3: {},
      page: 1,
      file: null,
      id: "",
      multipleSelection: [],
      userCode: this.$role.code,
      staRadio: "学习资料",
      learndata: [], // 学习资料列表
      learnnoun: [], // 专业名词列表
      learnlink: [], // 网络连接列表
      columns1: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "序号",
          type: "index"
        },
        {
          title: "标题",
          key: "title",
          ellipsis: true
        },
        {
          title: "资料介绍",
          key: "description",
          ellipsis: true
        },
        {
          title: "创建者",
          key: "userCode"
        },
        {
          title: "上传时间",
          key: "createdTime",
          width: 180,
          render: (h, params) => {
            return h(
              "p",
              {},
              dayjs(params.row.createdTime).format("YYYY-MM-DD HH:mm:ss")
            );
          }
        },
        {
          title: "导出",
          render: (h, params) => {
            return h("div", [
              h("i", {
                class: "icon-daochu iconfont",
                fixed: "center",
                style: "font-size:20px",
                on: {
                  click: () => {
                    //
                    this.downloadFile(params.row.fileUri);
                  }
                }
              })
            ]);
          }
        }
      ],
      ruleForm: {
        description: "",
        title: "",
        seq: 1
      },
      columns2: [
        {
          title: "序号",
          type: "index"
        },
        {
          title: "名词",
          key: "noun",
          ellipsis: true
        },
        {
          title: "内容",
          key: "content",
          ellipsis: true,
          render: (h, params) => {
            return h("div", [
              h(
                "div",
                {
                  on: {
                    click: () => {
                      this.confirmcontent(params.row);
                    }
                  },
                  style: {
                    cursor: "pointer",
                    color: "#2d8cf0"
                  }
                },
                params.row.content
              )
            ]);
          }
        },
        {
          title: "创建者",
          key: "userCode"
        }
      ],
      ruleForm2: {
        content: "",
        noun: "",
        seq: 1
      },
      rules2: {
        noun: [{ required: true, message: "请输入名词", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }]
      },
      columns3: [
        {
          title: "序号",
          type: "index"
        },
        {
          title: "标题",
          key: "title",
          ellipsis: true
        },
        {
          title: "链接",
          key: "link",
          ellipsis: true,
          render: (h, params) => {
            const url = `${params.row.link}`;
            return h(
              "a",
              {
                attrs: {
                  href: url,
                  target: "_black"
                }
              },
              params.row.link
            );
          }
        },
        {
          title: "创建者",
          key: "userCode"
        }
      ],
      rules3: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        link: [{ required: true, message: "请输入链接", trigger: "blur" }]
      },
      ruleForm3: {
        title: "",
        link: "",
        seq: 1
      }
    };
  },
  methods: {
    searchclass() {
      // 查询此学生所在的班级
      const data = {
        id: this.userCode
      };
      this.$http.getClassMemberByCode(data).then(res => {
        if (res.data.success) {
          console.log(res.data.data);
          this.stuclass = res.data.data.className;
          const data1 = {
            name: this.stuclass
          };
          this.$http.listClassRequest(data1).then(res1 => {
            if (res1.data.success) {
              this.stuteacher = res1.data.data.list[0].teacherCode;

              this.learnlist(1);
              this.NounList(1);
              this.LinkList(1);
            }
          });
        }
      });
    },
    confirmcontent(row) {
      // 弹出确定内容模态框
      this.$Modal.info({
        title: row.noun,
        content: row.content
      });
    },
    uploadlearn() {
      this.ruleForm = {
        description: "",
        title: "",
        seq: 1
      };
      this.$forceUpdate();
      this.modal1 = true;
    },
    handleCurrentChange(page) {
      // 分页函数
      this.learnlist(page);
    },
    handleCurrentChange2(page) {
      // 分页函数
      this.NounList(page);
    },
    handleCurrentChange3(page) {
      // 分页函数
      this.LinkList(page);
    },
    handleSelectionChange(val) {
      // 多选操作
      this.multipleSelection = val;
    },
    downloadFile(url, fileName) {
      // 下载单个文件
      const a = document.createElement("a");
      a.href = url;
      if (fileName) {
        a.download = fileName;
      } else {
        a.download = "";
      }
      a.click();
    },
    downloadfiledx() {
      if (this.multipleSelection.length === 0) {
        this.$Message.info("暂无可导出资料");
        return;
      }
      // 打包下载文件
      const data = {
        ids: []
      };
      for (let e = 0; e < this.multipleSelection.length; e++) {
        data.ids.push(this.multipleSelection[e].id);
      }
      data.ids = JSON.stringify(data.ids);
      this.$http.downLoadZipFile(data).then(res => {
        // if (res.data.success) {

        this.downloadFile(res.data, "批量下载");
        this.$Message.success("正在下载");
        // }
      });
    },
    learnlist(x) {
      // 学习资料列表
      const data = {
        pageSize: 10,
        pageNo: x,
        userId: this.stuteacher
      };
      this.$http.learndata(data).then(res => {
        if (res.data.success) {
          if (res.data.data.list) {
            this.learndata = res.data.data.list;
          }
          this.pageData = res.data.data;
        }
      });
    },
    NounList(x) {
      // 查询专业名词
      const pageNo = x || 1;
      const data = {
        pageSize: 10,
        pageNo,
        userId: this.stuteacher
      };
      this.$http.NounList(data).then(res => {
        if (res.data.success) {
          if (res.data.data.list) {
            this.learnnoun = res.data.data.list;
          }
          this.pageData2 = res.data.data;
          //
        }
      });
    },
    LinkList(x) {
      // 查询网络链接
      const pageNo = x || 1;
      const data = {
        pageSize: 10,
        pageNo,
        userId: this.stuteacher
      };
      this.$http.LinkList(data).then(res => {
        if (res.data.success) {
          if (res.data.data.list) {
            this.learnlink = res.data.data.list;
          }
          this.pageData3 = res.data.data;
          //
        }
      });
    }
  },
  created() {
    if (this.$role.role !== "student") {
      this.stuteacher = this.$role.code;
      this.learnlist(1);
      this.NounList(1);
      this.LinkList(1);
    } else {
      this.searchclass();
    }
  }
};
</script>
<style lang="stylus">
.datacenter
  width 1128px
  margin 50px auto
  margin-bottom 0px
  text-align left
  overflow hidden
  .ivu-table-wrapper
    border-color #EEF2F5
    .ivu-table:after
      background #EEF2F5
      z-index -99
    .ivu-table:before
      background-color #EEF2F5
    .ivu-table
      background #EEF2F5
      padding-bottom 2px
      font-size 14px
      thead
        tr
          th
            background #EEF2F5
            font-weight bolder
            color #000
      tbody
        tr
          td
            // text-align: center;
            border-top 1px solid #b7b7b7
            border-collapse unset
            box-sizing border-box
            height 40px
            &:first-child
              border-left 1px solid #b7b7b7
              border-radius 8px 0 0 8px
            &:last-child
              border-right 1px solid #b7b7b7
              border-radius 0 8px 8px 0
          &:last-child
            td
              border-bottom 1px solid #b7b7b7 !important
  .ivu-table-tip
    tr
      td
        &:last-child
          border-radius 8px 8px 8px 8px !important
  .RadioGroup
    display block
    text-align left
  .page
    margin-top 20px
    float right
</style>
